import React, { useEffect } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";

/**
 * MobileSidebar - slide-out drawer that wraps the existing <Navigation />.
 *
 * Closes when:
 *  - the user taps the overlay backdrop
 *  - a navigation link is clicked (detected via route change)
 *  - the parent toggles `isOpen` to false (hamburger button)
 */
export function MobileSidebar({ isOpen, onClose, children }) {
    const location = useLocation();

    // Close sidebar on route change (user tapped a nav link)
    useEffect(() => {
        if (isOpen) {
            onClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    // Prevent body scroll while sidebar is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    return (
        <>
            <Overlay $isOpen={isOpen} onClick={onClose} />
            <Drawer $isOpen={isOpen}>{children}</Drawer>
        </>
    );
}

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 1200;
    background: rgba(0, 0, 0, 0.5);

    opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
    pointer-events: ${({ $isOpen }) => ($isOpen ? "auto" : "none")};
    transition: opacity 0.25s ease;
`;

const Drawer = styled.aside`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 1201;

    width: 85vw;
    max-width: 360px;

    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    transform: ${({ $isOpen }) =>
        $isOpen ? "translateX(0)" : "translateX(-100%)"};
    transition: transform 0.3s ease;

    /* The nav inside will fill the drawer */
    > nav {
        width: 100%;
        min-height: 100%;
    }
`;
